<script setup lang="ts">
import iconList  from '@/constants/lucideicons'
import { computed } from 'vue';

const props = defineProps({
    name: {
        type: String,
        required: true
    },
    size: Number,
    color: String,
    strokeWidth: Number,
    defaultClass: String
})

const icon = computed(() => iconList[props.name as keyof typeof iconList]);

</script>
<template>
    <component :is="icon" :size="size" :color="color" :stroke-width="strokeWidth" :default-class="defaultClass" />
</template>
